(function() {

  // ── PRICING ──
  // 50pc minimum, 50-piece increments
  var COIN_175 = [9.75, 8.00, 6.15, 5.75, 5.50, 5.00, 4.75, 4.50, 4.25];
  var COIN_2IN = [10.25, 8.50, 6.15, 5.75, 5.50, 5.15, 4.90, 4.60, 4.25];
  var COIN_QTY_LABELS = ["50","75","100","150","200","250","300","400","500"];
  var COIN_QTY_MIN    = [50, 75, 100, 150, 200, 250, 300, 400, 500];

  // Add-on costs per coin
  var ADDON_EPOXY   = 0.35;
  var ADDON_GOLD    = 0.40;
  var ADDON_GEAR    = 0.40;
  var ADDON_GLOW_W  = 0.40;
  var ADDON_GLOW_C  = 0.25;
  var ADDON_SEQNUM  = 0.50;

  // 3D mold flat fee (shown separately)
  var MOLD_2D = 110;  // 2" 2D+2D base
  var MOLD_3D = 150;  // 2" 3D+3D

  var coinSize   = "175";
  var coinQty    = 100;
  var mold3D     = false;
  var addonEpoxy = false;
  var addonGold  = false;
  var addonGear  = false;
  var addonGlowW = false;
  var addonGlowC = false;
  var addonSeq   = false;

  function fmt(n)  { return "$" + n.toFixed(2); }
  function fmtI(n) { return "$" + Math.round(n).toLocaleString(); }

  function clampQty(v) { return Math.max(50, Math.min(99999, parseInt(v) || 50)); }

  function getTier(qty) {
    for (var i = COIN_QTY_MIN.length - 1; i >= 0; i--) {
      if (qty >= COIN_QTY_MIN[i]) return i;
    }
    return 0;
  }

  function getAddonPerCoin() {
    var total = 0;
    if (addonEpoxy) total += ADDON_EPOXY;
    if (addonGold)  total += ADDON_GOLD;
    if (addonGear)  total += ADDON_GEAR;
    if (addonGlowW) total += ADDON_GLOW_W;
    if (addonGlowC) total += ADDON_GLOW_C;
    if (addonSeq)   total += ADDON_SEQNUM;
    return total;
  }

  function getMoldFee() {
    var base = coinSize === "175" ? 100 : 110;
    return mold3D ? (coinSize === "175" ? 140 : 150) : base;
  }

  function buildProgressBar(ti) {
    var prices = coinSize === "175" ? COIN_175 : COIN_2IN;
    var html = '<div class="cl-progress-wrap"><div class="cl-progress-label">QUANTITY TIER</div><div class="cl-progress-track">';
    COIN_QTY_LABELS.forEach(function(label, i) {
      var isActive = i === ti;
      var isPast   = i < ti;
      var isLast   = i === COIN_QTY_LABELS.length - 1;
      var cls = "cl-progress-step" + (isActive ? " cl-prog-active" : "") + (isPast ? " cl-prog-past" : "");
      html += '<div class="' + cls + '" onclick="clJumpTier(' + i + ')">';
      html += '<div class="cl-prog-dot"></div>';
      html += '<div class="cl-prog-qty">' + label + (isLast ? "+" : "") + '</div>';
      html += '<div class="cl-prog-price">' + fmt(prices[i]) + '</div>';
      html += '</div>';
      if (i < COIN_QTY_LABELS.length - 1) {
        html += '<div class="cl-progress-line' + (i < ti ? ' cl-prog-line-done' : '') + '"></div>';
      }
    });
    html += '</div></div>';
    return html;
  }

  function buildSavings(ti, basePrice) {
    var prices = coinSize === "175" ? COIN_175 : COIN_2IN;
    if (ti === 0) {
      var nextPrice = prices[1];
      var nextMin   = COIN_QTY_MIN[1];
      var saving    = (basePrice - nextPrice) * nextMin;
      return '<div class="cl-savings-box cl-savings-nudge">' +
        '<span class="cl-savings-icon">&#11041;</span>' +
        '<span class="cl-savings-text">Step up to <strong>' + nextMin + ' coins</strong> and drop to <strong>' + fmt(nextPrice) + ' each</strong> &mdash; saving <strong>' + fmtI(saving) + '</strong> on your order</span>' +
        '</div>';
    }
    var prevPrice   = prices[ti - 1];
    var prevLabel   = COIN_QTY_LABELS[ti - 1];
    var savedVsPrev = (prevPrice - basePrice) * coinQty;
    var savedPct    = Math.round((prevPrice - basePrice) / prevPrice * 100);
    return '<div class="cl-savings-box cl-savings-win">' +
      '<span class="cl-savings-icon">&#11041;</span>' +
      '<span class="cl-savings-text">Down from <strong>' + fmt(prevPrice) + '</strong> at the ' + prevLabel + '-piece tier &mdash; <strong>' + savedPct + '% less per coin</strong>, saving <strong>' + fmtI(savedVsPrev) + '</strong> at this quantity</span>' +
      '</div>';
  }

  function render() {
    var input = document.getElementById("cl-qty-input");
    if (!input) return;
    coinQty = clampQty(input.value);
    input.value = coinQty;

    var prices    = coinSize === "175" ? COIN_175 : COIN_2IN;
    var ti        = getTier(coinQty);
    var basePrice = prices[ti];
    var addonPer  = getAddonPerCoin();
    var price     = basePrice + addonPer;
    var moldFee   = getMoldFee();
    var isMax     = ti === COIN_QTY_MIN.length - 1;
    var sizeLabel = coinSize === "175" ? "1.75&quot; COIN" : "2&quot; COIN";
    var moldLabel = mold3D ? "3D SCULPTURED MOLD" : "2D FLAT MOLD";

    // Qty label
    var ql = document.getElementById("cl-qty-label");
    if (ql) ql.innerHTML = "TIER: <span>" + (isMax ? "500+ COINS" : COIN_QTY_LABELS[ti] + "–" + (COIN_QTY_MIN[ti+1]-1) + " COINS") + "</span>";

    // Progress bar
    var progEl = document.getElementById("cl-progress");
    if (progEl) progEl.innerHTML = buildProgressBar(ti);

    // Savings
    var savEl = document.getElementById("cl-savings");
    if (savEl) savEl.innerHTML = buildSavings(ti, basePrice);

    // Addon lines
    var addonLines = "";
    if (addonEpoxy) addonLines += "<div class='cl-sum-row'><span class='cl-sum-name'>EPOXY COATING <span class='cl-sum-sub'>+" + fmt(ADDON_EPOXY) + "/coin</span></span><span class='cl-sum-val cl-sum-muted'>" + fmtI(ADDON_EPOXY * coinQty) + "</span></div>";
    if (addonGold)  addonLines += "<div class='cl-sum-row'><span class='cl-sum-name'>GOLD PLATING <span class='cl-sum-sub'>+" + fmt(ADDON_GOLD) + "/coin</span></span><span class='cl-sum-val cl-sum-muted'>" + fmtI(ADDON_GOLD * coinQty) + "</span></div>";
    if (addonGear)  addonLines += "<div class='cl-sum-row'><span class='cl-sum-name'>GEAR EDGE <span class='cl-sum-sub'>+" + fmt(ADDON_GEAR) + "/coin</span></span><span class='cl-sum-val cl-sum-muted'>" + fmtI(ADDON_GEAR * coinQty) + "</span></div>";
    if (addonGlowW) addonLines += "<div class='cl-sum-row'><span class='cl-sum-name'>GLOW &mdash; WHITE <span class='cl-sum-sub'>+" + fmt(ADDON_GLOW_W) + "/coin</span></span><span class='cl-sum-val cl-sum-muted'>" + fmtI(ADDON_GLOW_W * coinQty) + "</span></div>";
    if (addonGlowC) addonLines += "<div class='cl-sum-row'><span class='cl-sum-name'>GLOW &mdash; COLOR <span class='cl-sum-sub'>+" + fmt(ADDON_GLOW_C) + "/coin</span></span><span class='cl-sum-val cl-sum-muted'>" + fmtI(ADDON_GLOW_C * coinQty) + "</span></div>";
    if (addonSeq)   addonLines += "<div class='cl-sum-row'><span class='cl-sum-name'>SERIAL NUMBERING <span class='cl-sum-sub'>+" + fmt(ADDON_SEQNUM) + "/coin</span></span><span class='cl-sum-val cl-sum-muted'>" + fmtI(ADDON_SEQNUM * coinQty) + "</span></div>";

    var subtotal = price * coinQty;
    var total    = subtotal + moldFee;

    // Summary
    var sumEl = document.getElementById("cl-summary");
    if (sumEl) {
      sumEl.innerHTML =
        "<div class='cl-sum-title'>STARTING ESTIMATE &mdash; " + sizeLabel + " &middot; " + coinQty + " COINS &middot; " + moldLabel + "</div>" +
        "<div class='cl-sum-row'><span class='cl-sum-name'>STARTING PRICE PER COIN <span class='cl-sum-sub'>Before final design review &middot; shipping quoted separately</span></span><span class='cl-sum-val cl-sum-hero'>" + fmt(basePrice) + "</span></div>" +
        "<div class='cl-sum-row'><span class='cl-sum-name'>&times; " + coinQty + " COINS</span><span class='cl-sum-val cl-sum-muted'>" + fmtI(basePrice * coinQty) + "</span></div>" +
        addonLines +
        "<div class='cl-sum-row'><span class='cl-sum-name'>" + moldLabel + " <span class='cl-sum-sub'>One-time &mdash; waived on reorders of same design</span></span><span class='cl-sum-val cl-sum-muted'>" + fmt(moldFee) + "</span></div>" +
        "<div class='cl-sum-row cl-sum-total'><span class='cl-sum-name'>ESTIMATED TOTAL</span><span class='cl-sum-val cl-sum-green'>" + fmtI(total) + "</span></div>" +
        "<div class='cl-sum-note'><strong>&#11041; Starting estimate only.</strong> Every coin is custom. Your final price depends on your final design, size, shape, colors, finish and options. This estimate assumes a standard round coin, 3.5mm thick, up to 4 colors per side. We send you an exact quote and a proof to approve before anything is made. Shipping quoted separately.</div>";
    }

    // Tier table
    var tbody = "";
    COIN_QTY_LABELS.forEach(function(label, i) {
      var p = prices[i] + addonPer;
      var isLast = i === COIN_QTY_LABELS.length - 1;
      var badge = i > 0 ? ' <span class="cl-tbl-save">-' + Math.round((prices[0]-prices[i])/prices[0]*100) + '%</span>' : '<span class="cl-tbl-base">BASE</span>';
      tbody += "<tr class='" + (i === ti ? "cl-row-hl" : "") + "'>" +
        "<td>" + label + (isLast ? "+" : "") + " coins</td>" +
        "<td>" + fmt(p) + " ea" + badge + "</td>" +
        "<td>" + fmtI(p * COIN_QTY_MIN[i] + moldFee) + (isLast ? "+" : "") + "</td>" +
        "</tr>";
    });
    var tb = document.getElementById("cl-tbody");
    if (tb) tb.innerHTML = tbody;
  }

  // ── GLOBAL FUNCTIONS ──
  window.clSwitchSize = function(size, el) {
    coinSize = size;
    document.querySelectorAll(".cl-size-btn").forEach(function(b) { b.classList.remove("cl-size-on"); });
    el.classList.add("cl-size-on");
    render();
  };

  window.clToggleMold = function(el) {
    mold3D = !mold3D;
    el.classList.toggle("cl-addon-on");
    render();
  };

  window.clToggleAddon = function(addon, el) {
    if (addon === "epoxy") addonEpoxy = !addonEpoxy;
    if (addon === "gold")  addonGold  = !addonGold;
    if (addon === "gear")  addonGear  = !addonGear;
    if (addon === "gloww") addonGlowW = !addonGlowW;
    if (addon === "glowc") addonGlowC = !addonGlowC;
    if (addon === "seq")   addonSeq   = !addonSeq;
    el.classList.toggle("cl-addon-on");
    render();
  };

  window.clAdjQty = function(d) {
    coinQty = clampQty(coinQty + d);
    var input = document.getElementById("cl-qty-input");
    if (input) input.value = coinQty;
    render();
  };

  window.clOnQtyInput = function(v) {
    var n = parseInt(v);
    if (!isNaN(n) && n >= 50) { coinQty = Math.min(99999, n); render(); }
  };

  window.clJumpTier = function(i) {
    coinQty = COIN_QTY_MIN[i];
    var input = document.getElementById("cl-qty-input");
    if (input) input.value = coinQty;
    render();
  };

  // ── SCROLL BUTTON ──
  document.querySelectorAll('.coinlab-scroll-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById('coin-quote-form');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ── CONTACT FORM ──
  var form = document.getElementById('coin-contact-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('coin-submit-btn');
      var ok  = document.getElementById('coin-success');
      var err = document.getElementById('coin-error');
      btn.disabled = true;
      btn.textContent = 'SENDING...';
      ok.style.display = 'none';
      err.style.display = 'none';
      fetch('https://api.web3forms.com/submit', { method: 'POST', body: new FormData(form) })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d.success) { ok.style.display = 'block'; form.reset(); }
          else { err.style.display = 'block'; }
          btn.textContent = 'SEND MY REQUEST →';
          btn.disabled = false;
        })
        .catch(function() {
          err.style.display = 'block';
          btn.textContent = 'SEND MY REQUEST →';
          btn.disabled = false;
        });
    });
  }

  // ── INIT ──
  function tryInit() {
    if (document.getElementById("cl-summary")) {
      render();
    } else {
      setTimeout(tryInit, 50);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInit);
  } else {
    tryInit();
  }
  setTimeout(function() {
    if (document.getElementById("cl-summary") && !document.getElementById("cl-summary").innerHTML) render();
  }, 500);

})();